import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import InvoiceHeader from '../layout/invoice/InvoiceHeader';
import InvoiceAddress from '../layout/invoice/InvoiceAddress';
import InvoiceTable from '../layout/invoice/InvoiceTable';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { COMPANY_DETAILS, CREDIT_NOTE_DETAILS } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import { generatePDF } from '../../pdf/GeneratePDF';
import { useReactToPrint } from 'react-to-print';

export default function ViewCreditNote() {
     const [creditNote, setcreditNote] = useState({});
     const [details, setcreditNoteDetails] = useState([]);
     const [company, setCompanyDetails] = useState({});
     const [customer, setCustomer] = useState({});
     const { t } = useTranslation();

     const { id } = useParams();

     const componentRef = React.useRef();

     const handlePrint = useReactToPrint({
          content: () => componentRef.current,
     });

     useEffect(() => {
          getcreditNoteDetails();
          getCompanyDetails();
     }, []);


     const getcreditNoteDetails = async (e) => {
          const res = await httpClient.post(CREDIT_NOTE_DETAILS, { credit_note_id: id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let c = result.data.credit_note;
                    c['invoice_date'] = c.date;
                    setcreditNote(c);
                    setcreditNoteDetails(result.data.details);
                    setCustomer(result.data.customer);
               }
          }
     }

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setCompanyDetails(result.data);
               }
          };
     }

     const makePdf = () => {
          let filename = `${creditNote.number}-CREDIT-NOTE`;
          console.log(filename);
          generatePDF(filename);
     };

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="view_credit_note" subTitle="credit_notes" subTitleLink="root/credit-note" />
                    <div className="card col-md-11 m-auto" id="invoice">
                         <div className="card-body" id="print_section" ref={componentRef}>
                              <InvoiceHeader title="credit_note" number={`${creditNote.prefix}-${creditNote.number}`} />
                              <InvoiceAddress title="credit_note" customer={customer} company={company} order={creditNote} />
                              <InvoiceTable title="bill_to" products={details} order={creditNote} company={company} customer={customer} />
                         </div>
                         <div className='text-center'>
                              <Link to={`/root/credit-note/edit/${id}`} type="button" className="btn btn-sm btn-primary btn-icon-text m-1">
                                   {t('edit')}
                              </Link>
                              <button className="btn btn-sm btn-danger btn-icon-text m-1" onClick={makePdf}>{t('pdf')}</button>
                              <button className="btn btn-sm btn-info btn-icon-text m-1" onClick={handlePrint}>{t('print')}</button>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
